import { render, staticRenderFns } from "./ProductionInformDisplay.vue?vue&type=template&id=620c8715&"
import script from "./ProductionInformDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductionInformDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductionInformDisplay.vue?vue&type=style&index=0&id=620c8715&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports